/**
 * history helper so we can use the react-router history prop outside react components
 */

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;
